import { render, staticRenderFns } from "./wxCourseDetail.vue?vue&type=template&id=f8e6b6fc&scoped=true&"
import script from "./wxCourseDetail.vue?vue&type=script&lang=js&"
export * from "./wxCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./wxCourseDetail.vue?vue&type=style&index=0&id=f8e6b6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e6b6fc",
  null
  
)

export default component.exports